import { inject, Injectable } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Fabric } from '../../models/fabric/fabric';
import { ApiResponse, PaginatedApiResponse } from '@card-software/library';
import { ItemMaster } from '../../models/item/item-master';

@Injectable({
  providedIn: 'root',
})
export class FabricProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/fabric';

  public batchFabrics(fabrics: string[]): Observable<ApiResponse<Fabric[]>> {
    return this.httpClient.post<ApiResponse<Fabric[]>>(`${this.baseUrl}/fabric-code/batch`, fabrics);
  }

  public batchItemMasterByFabricCodes(fabricCodes: string[]): Observable<ApiResponse<Record<string, ItemMaster | null>>> {
    return this.httpClient.post<ApiResponse<Record<string, ItemMaster | null>>>(
      `${this.baseUrl}/fabric-code/batch/item-master`,
      fabricCodes,
    );
  }

  public search(
    command: { fabricCode?: string; longDescription?: string },
    matchAny = true,
  ): Observable<ApiResponse<PaginatedApiResponse<Fabric>>> {
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<Fabric>>>(`${this.baseUrl}/search?matchAny=${matchAny}`, command);
  }
}
